import { render, staticRenderFns } from "./AnxinRefundList.vue?vue&type=template&id=5516abbc&scoped=true"
import script from "./AnxinRefundList.vue?vue&type=script&lang=js"
export * from "./AnxinRefundList.vue?vue&type=script&lang=js"
import style0 from "./AnxinRefundList.vue?vue&type=style&index=0&id=5516abbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516abbc",
  null
  
)

export default component.exports